import { Center, Content, PostCallWrapper, Logo, Title, Description, PoweredBy } from './PostCallStyle';
import { ReactComponent as Illustration } from 'assets/illustrations/illustration.svg';
import { ReactComponent as LogoIconSvg } from 'assets/logos/logoIcon.svg';
import { ReactComponent as LogoTextSvg } from 'assets/logos/logoText.svg';
import { poweredByLink } from '../shared/variables';
import { useTranslation } from 'react-i18next';
import { State } from '../types/Video';

type PostCallProps = {
  changeCurrentState: (state: State) => void;
  isVideoUpgrade?: boolean;
};

export const PostCall = ({ changeCurrentState, isVideoUpgrade = false }: PostCallProps) => {
  const { t } = useTranslation();
  return (
    <PostCallWrapper>
      {/*<Logo>*/}
      {/*  <div>*/}
      {/*    <LogoIconSvg />*/}
      {/*  </div>*/}
      {/*  <LogoTextSvg />*/}
      {/*</Logo>*/}
      <Center>
        <Content>
          <Title>
            <span>{t('postCall.title')}</span>
            <Illustration />
          </Title>
          {!isVideoUpgrade && (
            <Description>
              <span>{t('postCall.desc1')}</span>
              <span>{t('postCall.desc2')}</span>
              <strong>{t('postCall.closing')}</strong>
            </Description>
          )}
        </Content>
      </Center>
      <PoweredBy>
        <a href={poweredByLink} target="_blank" aria-label={`${t('common.poweredBy')} ${t('common.opensInNewTab')}`}>
          {t('common.poweredBy')}
          <span className="sr-only">{t('common.opensInNewTab')}</span>
        </a>
      </PoweredBy>
    </PostCallWrapper>
  );
};
